import { render, staticRenderFns } from "./dynamicFormWrapper.vue?vue&type=template&id=cdc12602&scoped=true&"
import script from "./dynamicFormWrapper.vue?vue&type=script&lang=js&"
export * from "./dynamicFormWrapper.vue?vue&type=script&lang=js&"
import style0 from "./dynamicFormWrapper.vue?vue&type=style&index=0&id=cdc12602&lang=scss&scoped=true&"
import style1 from "./dynamicFormWrapper.vue?vue&type=style&index=1&id=cdc12602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc12602",
  null
  
)

export default component.exports